import React from 'react'

import { Text } from '@wartek-id/text'
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleIcon,
  CollapsibleContent,
} from '@wartek-id/collapsible'

import type { FAQItemProps } from '../../types/faq'

const FAQ3 = (props: FAQItemProps) => {
  return (
    <Collapsible {...props}>
      <CollapsibleTrigger className="!text-left">
        <Text variant="body-sm" className="!font-semibold">
          Apakah soal Asesmen Pembelajaran bisa digunakan untuk ulangan harian?
        </Text>
        <CollapsibleIcon></CollapsibleIcon>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4">
        <Text className="mb-6">
          <b>Bisa</b>, selain itu dapat juga digunakan untuk{' '}
          <b>memperoleh umpan balik</b> dari hasil pembelajaran.
        </Text>

        <Text className="mb-6">
          Perlu diketahui, ulangan harian tidak harus berbentuk tes, ada{' '}
          <b>
            berbagai teknik dan instrumen yang bisa digunakan sebagai asesmen
            sumatif
          </b>
          . Ragam pilihan ini sudah tersedia di dalam fitur Asesmen
          Pembelajaran.
        </Text>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default FAQ3
